// frontend/utils/dateUtils.ts

/**
 * 날짜를 현재 시각 기준 상대적 표현으로 변환합니다.
 * cutoffDays가 넘으면 절대 날짜(월/일)를 표시합니다.
 */
export function formatRelativeTime(dateStr: string | null | undefined, cutoffDays = 7): string {
  if (!dateStr) return "";
  const now = Date.now();
  const diff = now - new Date(dateStr).getTime();
  const minutes = Math.floor(diff / 60_000);
  const hours = Math.floor(diff / 3_600_000);
  const days = Math.floor(diff / 86_400_000);
  if (minutes < 1) return "방금";
  if (minutes < 60) return `${minutes}분 전`;
  if (hours < 24) return `${hours}시간 전`;
  if (days < cutoffDays) return `${days}일 전`;
  const d = new Date(dateStr);
  if (d.getFullYear() !== new Date(now).getFullYear()) {
    return `${d.getFullYear()}년 ${d.getMonth() + 1}월 ${d.getDate()}일`;
  }
  return `${d.getMonth() + 1}월 ${d.getDate()}일`;
}

/**
 * 날짜를 "YYYY. M. D. 오전/오후 H:MM" 형식으로 변환합니다.
 * 활동 로그·버전 기록 패널의 절대 시각 표시에 사용됩니다.
 */
export function formatFullDate(dateStr: string): string {
  const d = new Date(dateStr);
  const ampm = d.getHours() < 12 ? "오전" : "오후";
  const h = d.getHours() % 12 || 12;
  const m = String(d.getMinutes()).padStart(2, "0");
  return `${d.getFullYear()}. ${d.getMonth() + 1}. ${d.getDate()}. ${ampm} ${h}:${m}`;
}

export function formatDateOnly(dateStr: string | null | undefined): string {
  return dateStr
    ? new Date(dateStr).toLocaleDateString("ko-KR", { year: "numeric", month: "numeric", day: "numeric" })
    : "";
}
